import { createSelector } from '@reduxjs/toolkit';
import { selectWithNeighborsOptions } from './selectWithNeighborsOptions';
import { selectWithNeighborsByDefaultOff } from './selectWithNeighborsByDefaultOff';
import { IConfig } from '@cian/config/shared';
import { selectWithNeighbors } from 'shared/selectors/jsonQuery';
import { selectWithNeighborsVisible } from './selectWithNeighborsVisible';

export const selectWithNeighborsFilter = (config: IConfig) => {
  const isOffByDefaultSelector = selectWithNeighborsByDefaultOff(config);
  const withNeighborsVisibleSelector = selectWithNeighborsVisible(config);

  return createSelector(
    [selectWithNeighbors, selectWithNeighborsOptions, isOffByDefaultSelector, withNeighborsVisibleSelector],
    (withNeighbors, options, isOffByDefault, visible) => ({
      label: 'Радиус поиска',
      value: [withNeighbors === null && !isOffByDefault ? true : Boolean(withNeighbors)],
      options,
      isOffByDefault,
      visible,
    }),
  );
};
